<div *ngIf="{ settings: instantBookSettings$ | async, saving: saving$ | async } as vm" fxLayout class="instant-book">
  <sbnb-subnav header="Direct">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists" fxLayout="column">
    <ng-container *ngTemplateOutlet="headerSection"></ng-container>

    <section *ngIf="vm.settings; else loading" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="column" fxLayoutGap.lt-md="12px">
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-slide-toggle [(ngModel)]="vm.settings.instant_book_enabled"></mat-slide-toggle>
          <span
            class="strong clickable"
            style="padding-left: 8px"
            (click)="vm.settings.instant_book_enabled = !vm.settings.instant_book_enabled">
            <span *ngIf="!(isPremium$ | async)">Automatically accept booking requests</span>
            <span *ngIf="isPremium$ | async">Instantly accept qualified bookings</span>
            ,
          </span>
          <span class="strong" style="padding-left: 4px">if booking is requested at least</span>
          <div class="dropdown-select" [matMenuTriggerFor]="afterBookingBufferMenu">
            {{ vm.settings.instant_book_days_before_checkin }}
            {{ vm.settings.instant_book_days_before_checkin === 1 ? 'day' : 'days' }}
          </div>
          <span class="strong">before check-in</span>
        </div>
        <span *ngIf="isPremium$ | async" class="card__collapsed-helper-text">
          Automatically accept bookings with a guest vetting risk level of green (lowest risk).
        </span>
        <mat-menu #afterBookingBufferMenu="matMenu">
          <div class="before-checkin-menu" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
            <mat-form-field class="nopadding short-number-input">
              <input
                autofocus
                matInput
                type="number"
                min="0"
                max="100"
                pattern="^(100|[1-9]?\d(\.\d\d?)?)$"
                [(ngModel)]="vm.settings.instant_book_days_before_checkin"
                (click)="$event.preventDefault(); $event.stopPropagation()" />
            </mat-form-field>

            <div>
              {{ vm.settings.instant_book_days_before_checkin === 1 ? 'day' : 'days' }}
            </div>
          </div>
        </mat-menu>
      </div>

      <div fxLayoutAlign="start center" class="save-button">
        <sbnb-button
          [loading]="vm.saving"
          label="Save changes"
          size="mini"
          type="primary"
          (clicked)="saveChanges(vm.settings)"></sbnb-button>
      </div>
    </section>
  </main>
</div>

<ng-template #headerSection>
  <section id="header" fxLayout="column">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <div fxLayout>
          <h2 class="nomargin" fxFlex>Instant Book</h2>
          <div
            *ngIf="recentlySaved"
            fxLayout
            fxLayoutAlign="center center"
            fxLayoutGap="6px"
            class="absolute right-0 sbnbDesktop:relative">
            <mat-icon class="grass-darker">check</mat-icon>
            <span class="grass-darker">Saved</span>
          </div>
        </div>
      </sbnb-page-header>

      <div fxLayout>
        <h2 class="nomargin" fxFlex>Instant Book</h2>
        <div *ngIf="recentlySaved" fxLayout fxLayoutAlign="center center" fxLayoutGap="6px">
          <mat-icon class="grass-darker">check</mat-icon>
          <span class="grass-darker">Saved</span>
        </div>
      </div>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'direct-instant-book'"></sbnb-helptext-wrapper>
  </section>
</ng-template>

<ng-template #loading>
  <mat-spinner [diameter]="32"></mat-spinner>
</ng-template>

<ng-template #errorSection let-vm="vm">
  <ng-container *ngIf="vm.loadingError">There was an error loading instant book settings.</ng-container>
</ng-template>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
